module.exports = __webpack_public_path__ + "img/five04.dcbd50ca.png";